import React, { useState } from 'react';
import Icon from '../../icons';
import { useDispatch, useSelector } from "react-redux";
import { exitAdmin } from '../../common/urlRouting';
import { useModules } from '@/utils/modules';
import { setActiveTopHeader } from '../../containers/Header/actions/action';

const AdminSettings = () => {
  const dispatch = useDispatch();
  const sessionContext= useSelector(state => state.sessionContextOidc);

  // Same as TopHeaderRight: containers/Header opens the matching right panel for activeHeader
  const onHeaderClick = (clickedTab) => {
    dispatch(setActiveTopHeader({ activeHeader: clickedTab }));
  };

  return (
    <div className='headerAdmin modalHeaderFixed'>
      <div className='headerMain'>
        <div className="modalHeaderccLogo" onClick={() => { checkTimezone(); window.location = `/workkards` }}>
          <span><Icon name="CasheLogo" className="" /></span>
        </div>
        <div className='headerLeft'>
          <h1>Admin Settings</h1>
        </div>
        <div className='headerRight'>
          <ul>
            <li id="refreshBtn">
              <button className="mr btn-cc btn-cc__transparent" onClick={() => onHeaderClick("notification")}><Icon name="notification" className="icon" /></button>
            </li>
            {
              useModules().isModuleEnabled("support") &&
              <li><Icon name="FaqCircle" className="icon" /></li>
            }
            <li className='alignMiddle'><button className='btn-cc__gray btn-cc__hover-off' onClick={() => exitAdmin(sessionContext?.organizationView?.Subdomain, sessionContext?.userView.permissions)}><Icon name="close" className="icon mr" /> Close</button></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;